export const LolDivisions = [
    'Iron IV',      // 00
    'Iron III',     // 01
    'Iron II',      // 02
    'Iron I',       // 03
    'Bronze IV',    // 04
    'Bronze III',   // 05
    'Bronze II',    // 06
    'Bronze I',     // 07
    'Silver IV',    // 08
    'Silver III',   // 09
    'Silver II',    // 10
    'Silver I',     // 11
    'Gold IV',      // 12
    'Gold III',     // 13
    'Gold II',      // 14
    'Gold I',       // 15
    'Platinum IV',  // 16
    'Platinum III', // 17
    'Platinum II',  // 18
    'Platinum I',   // 19
    'Diamond IV',   // 20
    'Diamond III',  // 21
    'Diamond II',   // 22
    'Diamond I',    // 23
    'Master',       // 24
    'Grandmaster',  // 25
    'Unranked',     // 26
    'Challenger',   // 27
];

export const Masteries = [
  'Mastery 0', //0
  'Mastery 1', //1
  'Mastery 2', //2
  'Mastery 3', //3
  'Mastery 4', //4
  'Mastery 5 (0 Token)', //5
  'Mastery 5 (1 Token)', //6
  'Mastery 6 (0 Token)', //7
  'Mastery 6 (1 Token)', //8
  'Mastery 6 (2 Token)', //9
  'Mastery 7', //10
];

export const MasteriesNumber = [
  'Mastery 0', //0
  'Mastery 1', //1
  'Mastery 2', //2
  'Mastery 3', //3
  'Mastery 4', //4
  'Mastery 5', //5
  'Mastery 6', //6
  'Mastery 7', //7
  'Mastery 8', //8
  'Mastery 9', //9
  'Mastery 10+', //10
];

export const MasteriesToken = [
  'Mastery 0', //0
  'Mastery 1', //1
  'Mastery 2', //2
  'Mastery 3', //3
  'Mastery 4', //4
  'Mastery 5', //5
  'Mastery 6', //6
  'Mastery 7', //7
  'Mastery 8', //8
  'Mastery 9', //9
  'Mastery 10+', //10
];
